import React from 'react';

import { Color } from '@/constants/color';
import { buttonVariants } from '@/ui/Button/Button';
import Button from '@/ui/components/Button';
import { colorToSemantic, sizeToSemantic, variantForColor } from '@/ui/components/Button/Button';
import Dropdown from '@/ui/components/Dropdown';
import Tooltip from '@/ui/components/Tooltip';

import type { ButtonGroupButtonProps, Props } from './types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const ButtonGroup = ({ buttons, wrapperClassName }: Props) => {
  const renderButton = (buttonProps: Partial<ButtonGroupButtonProps>, index: number) => {
    const className = 'rounded-none min-w-6 justify-center';
    const roundedClassNames =
      index === 0 ? 'rounded-l-md' : index === buttons.length - 1 ? 'rounded-r-md' : '';

    return buttonProps.isDropDown ? (
      <Dropdown
        key={`button-${index}`}
        // Build the dropdown button's classes with the same tailwind-variants function the
        // sibling Button components use, so it matches their height, color and border exactly.
        customButtonClassName={buttonVariants({
          variant: variantForColor((buttonProps.color as Color) || Color.WHITE),
          color: colorToSemantic[(buttonProps.color as Color) || Color.WHITE] ?? 'neutral',
          size: sizeToSemantic[buttonProps.size || 'xs'],
          className: `${className} ${roundedClassNames}`
        })}
        customWrapperClassName={`relative inline-block text-left ${buttonProps.className || ''}`}
        buttonText={buttonProps.buttonText || ''}
        {...buttonProps}
      />
    ) : (
      <Button
        key={`button-${index}`}
        color={Color.WHITE}
        size="xs"
        type="button"
        {...buttonProps}
        className={`${className} ${roundedClassNames} ${buttonProps.className || ''}`}
      />
    );
  };

  return (
    <span
      className={`isolate inline-flex rounded-md shadow-xs ${wrapperClassName ? wrapperClassName : ''}`}>
      {buttons.map((buttonProps, index) => {
        return buttonProps.tooltip ? (
          <Tooltip key={`button-${index}`} tooltipContent={buttonProps.tooltip}>
            {renderButton(buttonProps, index)}
          </Tooltip>
        ) : (
          renderButton(buttonProps, index)
        );
      })}
    </span>
  );
};
export default React.memo(ButtonGroup);
